<div class="wrapper">
    <div class="content-status-page">
        <app-paragraph [text]="statusText"></app-paragraph>
    </div>
</div>
